import React, { memo } from 'react';
import { styled } from '@compiled/react';
import type { Size } from '@atlaskit/icon';
import AddonIcon from '@atlaskit/icon/core/migration/app--addon';
import { token } from '@atlaskit/tokens';

type Props = {
	url?: string;
	size?: 'small';
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const AppIcon = styled.img<{ size?: Size }>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	width: ({ size }) => (size === 'small' ? token('space.200') : token('space.250')),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	height: ({ size }) => (size === 'small' ? token('space.200') : token('space.250')),
});

const AppItemIcon = ({ url, size }: Props) =>
	url != null && String(url).trim().length > 0 ? (
		<AppIcon src={url} alt="" size={size} />
	) : (
		<AddonIcon
			label=""
			spacing={size === 'small' ? 'none' : 'spacious'}
			color="currentColor"
			LEGACY_size={size}
		/>
	);

export default memo<Props>(AppItemIcon);
